import { Select, Typography } from 'antd';
import type { ReactNode } from 'react';
import tw from 'twin.macro';

export interface Pagination {
  query: {
    page: number;
    size: number;
  };
  total?: number;
  setPaginationValues: ({ page, size }: { page: number; size: number }) => void;
}

export interface HeaderConfig {
  title?: string;
  showTotalCount?: boolean;
  showSizeSelector?: boolean;
  extra?: ReactNode;
  sizeOptions?: number[];
}

interface Props extends HeaderConfig {
  pagination?: Pagination;
}

const Header = ({
  pagination,
  title,
  showTotalCount,
  showSizeSelector,
  extra,
  sizeOptions,
}: Props) => {
  const total = pagination?.total ?? 0;

  return (
    <div
      css={tw`flex flex-row items-center justify-between gap-y-[8px] my-[16px] w-full flex-wrap`}
    >
      <div css={tw`flex flex-row items-center gap-[12px]`}>
        {title && (
          <Typography css={tw`leading-[24px] text-[16px] font-semibold`}>
            {title}
          </Typography>
        )}

        {pagination?.total !== undefined && showTotalCount && (
          <Typography>총 {total.toLocaleString()}개</Typography>
        )}
      </div>

      <div css={tw`flex flex-row items-center gap-[8px] flex-wrap`}>
        {extra}

        {pagination?.query && showSizeSelector && (
          <Select
            style={{ width: 84 }}
            value={pagination?.query.size}
            onChange={(size) => {
              pagination.setPaginationValues({
                page: 1,
                size,
              });
            }}
          >
            {sizeOptions ? (
              sizeOptions.map((option) => (
                <Select.Option key={option} value={option}>
                  {option}
                </Select.Option>
              ))
            ) : (
              <>
                <Select.Option value={10}>10</Select.Option>
                <Select.Option value={50}>50</Select.Option>
                <Select.Option value={100}>100</Select.Option>
              </>
            )}
          </Select>
        )}
      </div>
    </div>
  );
};

export default Header;
